import { Pipe, PipeTransform } from "@angular/core";
import * as _ from "lodash";

@Pipe({
  name: "languageStatus",
})
export class LanguageStatusPipe implements PipeTransform {
  transform(array: any): any[] {
    return _.filter(array, {
      status: true,
    });
  }
}
